
const state = {
    tariffs: []
}

const getters = {
    
}

const mutations = {
    'SET_TARIFFS' (state, data) {
        state.tariffs = data
    }
}

const actions = {
    loadTariffs() {
        this.$http.get('/api/tariffs/')
    }
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}


// WEBPACK FOOTER //
// ./src/store/modules/db.js